"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
const submit_1 = require("./submit");
const close_1 = require("./close");
const refresh_1 = require("./refresh");
const createHistory_1 = require("./createHistory");
const getContext_1 = require("./getContext");
const changeWindowTitle_1 = require("./changeWindowTitle");
const theme_1 = require("./theme");
exports.view = {
    submit: submit_1.submit,
    close: close_1.close,
    refresh: refresh_1.refresh,
    createHistory: createHistory_1.createHistory,
    getContext: getContext_1.getContext,
    theme: theme_1.theme,
    changeWindowTitle: changeWindowTitle_1.changeWindowTitle
};
